"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendToSearch = appendToSearch;
exports.formatQueryString = formatQueryString;
exports.parseQueryString = parseQueryString;
exports.useQueryString = useQueryString;

var _reactRouterDom = require("react-router-dom");

var _react = require("react");

var _qs = _interopRequireDefault(require("qs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Export `parseQueryString`.
 */
function parseQueryString(search) {
  return _qs["default"].parse(search, {
    ignoreQueryPrefix: true
  });
}
/**
 * Export `formatQueryString`.
 */


function formatQueryString(query) {
  return _qs["default"].stringify(query);
}
/**
 * Export `appendToSearch`.
 */


function appendToSearch(search, query) {
  return "?".concat(formatQueryString(_objectSpread(_objectSpread({}, parseQueryString(search)), query)));
}
/**
 * Export `useQueryString`.
 */


function useQueryString() {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var query = (0, _react.useMemo)(function () {
    return parseQueryString(search);
  }, [search]);
  return query;
}